<template>
  <div class="resources">
    <div class="resources__header filters-bar">
      <div class="resources-export-button">
        <i-button
          class="export-table-button"
          @click="downloadModal = true"
          type="primary"
          icon="md-cloud-download"
        >
          Скачать документы
        </i-button>
      </div>
    </div>
    <inline-loader :loading="loading" v-if="loading && !nodata" />
    <div class="ms-nodata ms-text" v-else-if="!loading && nodata">
      Не удалось загрузить список материалов. Повторите, пожалуйста, попытку
      позже
    </div>
    <div class="resources-container" v-else>
      <div class="resources-block">
        <resources-group
          title="Основной договор"
          :resources="contractResources"
        />
        <resources-group
          v-for="amendment in amendments"
          :key="amendment.id"
          :title="`ДС №${amendment.number}`"
          :resources="amendment.resources"
        />
      </div>
      <div v-if="contragents.length" class="resources-block" style="margin-top: 64px">
        <div class="resources-block__title ms-text ms-main-head">
          Подрядные организации
        </div>
        <div>
          <resources-group
            v-for="contragent in contragents"
            :key="contragent.id"
            :title="contragent.performer_name"
            :resources="contragent.resources.contract || []"
          />
        </div>
      </div>
    </div>

    <modal v-model="downloadModal" width="360">
      <p slot="header" class="ms-text" style="text-align: center">
        <icon type="md-cloud-download" />
        <span style="margin-left: 4px">Скачивание материалов</span>
      </p>
      <div style="text-align: center">
        <p class="ms-text">Выберите типы материалов для скачивания</p>
        <div class="download-modal-content">
          <checkbox-group v-model="downloadTypes">
            <checkbox
              v-for="type in objectTypes"
              :key="type.type"
              :label="type.type"
              border
            >
              {{ type.name }}
            </checkbox>
          </checkbox-group>
          <checkbox style="margin-top: 16px" v-model="withoutContragent">
            Исключить документы подрядчиков
          </checkbox>
          <checkbox style="margin-top: 0px" v-model="onlyPdf">
            Оставить только сканы документов
          </checkbox>
        </div>
      </div>
      <div slot="footer">
        <i-button
          :loading="downloading"
          type="primary"
          size="default"
          long
          @click="exportDocuments"
        >
          {{ downloading ? "Подготовка к скачиванию..." : "Скачать документы" }}
        </i-button>
      </div>
    </modal>
  </div>
</template>

<script>
import InlineLoader from '@/components/loaders/inline-loader'
import ResourcesGroup from './resources-group'
import { downloadWithWidget } from '@/utils'
import { mainUrl } from '@/config/urls'
import { objectTypes } from '@/config/resources'
import { getResourcesUrl } from '@/config/filters'

export default {
  components: {
    InlineLoader,
    ResourcesGroup
  },
  data () {
    return {
      loading: false,
      nodata: false,
      contractResources: [],
      amendments: [],
      contragents: [],
      token: this.$store.state.auth.token,
      downloadModal: false,
      downloading: false,
      downloadTypes: ['contracts', 'acts'],
      withoutContragent: true,
      onlyPdf: false,
      objectTypes
    }
  },
  watch: {
    '$store.state.filters.resources': {
      handler: function () {
        this.getResources(true)
      },
      deep: true,
      immediate: false
    },
    '$store.state.socket': {
      handler: function (val) {
        if (!val.create && !val.update && !val.delete) return
        const { type } = this.$store.state.socket

        if (type === 'resources') {
          this.getResources(true)
        }

        this.$store.commit('CLEAR_SOCKET_STATE')
      },
      deep: true
    }
  },
  methods: {
    async getResources (noloading) {
      const { id } = this.$route.params

      try {
        if (!noloading) this.loading = true

        const url = getResourcesUrl(
          `page/all_document?contract_id=${id}`,
          this.$store.state.filters.resources
        )
        const {
          contract,
          amendments,
          contragents
        } = await this.$store.dispatch('GET_REQUEST', { url })
        this.contractResources = contract
        this.amendments = amendments
        this.contragents = contragents

        this.loading = false
      } catch (error) {
        console.log(error)
        this.nodata = true
        this.loading = false
      }
    },
    exportDocuments () {
      const { id } = this.$route.params
      const baseUrl = getResourcesUrl(
        `page/all_document?contract_id=${id}&as_file=true`
      )
      let params = `object_type=${this.downloadTypes.join(',')}`

      if (this.withoutContragent) {
        params += '&without_contragent=true'
      }

      if (this.onlyPdf) {
        params += '&format_type_id=1'
      }

      const url = `${mainUrl}/api/${baseUrl}&${params}&access_token=${this.token}`

      downloadWithWidget(this, url)

      this.downloading = true
    }
  },
  created () {
    this.getResources()
  }
}
</script>

<style lang="less">
.resources {
  &__header {
    display: flex;
    justify-content: flex-end;
  }

  &-block {
    &__title {
      font-size: 16px !important;
      margin-bottom: 16px;
    }
  }

  .ivu-tag {
    height: 30px;
    line-height: 30px;
    padding: 0 12px;
  }
}
</style>
